module.exports = __webpack_public_path__ + "img/play-icon-inactive.64c89698.svg";